import { useSuperAdminQueryHandler } from './use-query-handler'
import { SubmitHandler, useFieldArray, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { OptionSelect } from '@/core/utils/types'
import { t } from '@lingui/core/macro'

interface LinkExterno {
  id: string
  uri: string
  label: string
  uriHomolog: string
}

interface SuperAdminValues {
  produto: OptionSelect
  baseUriHomolog: string
  baseUri: string
  linksExternos: LinkExterno[]
}

export const useSuperAdminForm = () => {
  const { produtos, handleEditarProduto, buscarLinksExternos } =
    useSuperAdminQueryHandler()

  const form = useForm<SuperAdminValues>({
    defaultValues: {
      produto: undefined,
      baseUriHomolog: '',
      baseUri: '',
      linksExternos: []
    },
    resolver: zodResolver(
      z.object({
        produto: z.object(
          { value: z.string(), label: z.string() },
          { error: t`Produto é obrigatório` }
        ),
        baseUriHomolog: z.any(),
        baseUri: z.any(),
        linksExternos: z.any()
      })
    ),
    mode: 'all'
  })

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: 'linksExternos'
  })

  const onSubmit: SubmitHandler<SuperAdminValues> = async values => {
    try {
      if (!values.produto) return
      const linksExternos = values.linksExternos.map(i => ({
        id: i.id,
        uriHomolog: i.uriHomolog
      }))

      await handleEditarProduto(
        values.produto.value,
        values.baseUriHomolog,
        linksExternos
      )
    } catch (e) {
      console.error('Erro ao editar produto:', e)
    }
  }

  const handleProdutoChange = async (e: OptionSelect) => {
    const produto = produtos.find(p => p?.id === e.value)
    if (!produto) return

    form.setValue('produto', {
      value: produto.id,
      label: produto.nome
    })

    form.setValue('baseUriHomolog', produto.baseUriHomolog)
    form.setValue('baseUri', produto.baseUri)

    const { data } = await buscarLinksExternos({
      variables: {
        id: produto.id
      }
    })

    const links = data?.linksExternosByProduto ?? []
    const linksFiltered = links.filter(link => link.uri || link.uriHomolog)

    form.setValue('linksExternos', linksFiltered)
  }

  return {
    form,
    onSubmit,
    handleProdutoChange,
    produtos,
    fields,
    append,
    remove
  }
}
